import {
  DropdownAction,
  SimpleAction,
  StandardAction,
  StandardActionBuilder,
} from '@infodata-group/inf-commons';
import { of } from 'rxjs';

export class ToolsActions {
  public static getAddAction(): StandardAction {
    return new StandardAction(
      'add',
      'plus',
      'i18n.common.actions.create',
      'i18n.common.actions.create',
    );
  }

  public static getEditAction(): StandardAction {
    return new StandardAction(
      'edit',
      'edit',
      'i18n.common.actions.edit',
      'i18n.common.actions.edit',
    );
  }

  public static getSaveAction(): StandardAction {
    return new StandardAction(
      'save',
      'save',
      'i18n.common.actions.save',
      'i18n.common.actions.save',
    );
  }

  public static getCloseAction(): StandardAction {
    return new StandardAction(
      'close',
      'times',
      'i18n.common.actions.close',
      'i18n.common.actions.close',
    );
  }

  public static getCreateAction(): StandardAction {
    return new StandardAction(
      'create',
      'plus',
      'i18n.common.actions.create',
      'i18n.common.actions.create',
    );
  }

  public static getDeleteAction(): StandardAction {
    return new StandardAction(
      'delete',
      'trash-alt',
      'i18n.common.actions.delete',
      'i18n.common.actions.delete',
    );
  }

  public static getExportAction(
    withPdf = true,
    withCsv = true,
  ): DropdownAction {
    const actions: StandardAction[] = [];
    if (withPdf) {
      actions.push(new SimpleAction('exportPdf', 'file-pdf', null, 'PDF'));
    }
    if (withCsv) {
      actions.push(new SimpleAction('exportCsv', 'file-csv', null, 'CSV'));
    }
    const action = new DropdownAction(
      'export-file',
      'download',
      of(actions),
      'i18n.common.actions.download-list',
    );
    action.tooltip = action.text;
    return action;
  }

  public static getCreatePresetAction(): StandardAction {
    return new StandardActionBuilder('create-preset', 'wand-magic-sparkles')
      .setTooltip('i18n.component.create-preset-from-parameters')
      .build();
  }

  public static getCustomRefreshAction(): StandardAction {
    return new StandardAction(
      'refreshCustom',
      'sync',
      'i18n.common.actions.refresh',
      'i18n.common.actions.refresh',
    );
  }

  public static getCancelAction(): StandardAction {
    return new StandardAction(
      'cancel',
      'times',
      'i18n.common.actions.cancel',
      'i18n.common.actions.cancel',
    );
  }

  public static getRefreshAction(): StandardAction {
    return new StandardAction(
      'refresh',
      'sync',
      'i18n.common.actions.refresh',
      'i18n.common.actions.refresh',
    );
  }

  public static getCopyAction(): StandardAction {
    return new StandardAction(
      'copy',
      'copy',
      'i18n.common.actions.copy',
      'i18n.common.actions.copy',
    );
  }

  public static getLinkAction(): StandardAction {
    return new StandardAction(
      'link',
      'link',
      'i18n.common.actions.link',
      'i18n.common.actions.link',
    );
  }

  public static getDownloadAction(): StandardAction {
    return new StandardAction(
      'download',
      'download',
      'i18n.common.actions.download',
      'i18n.common.actions.download',
    );
  }

  public static getDuplicateAction(): StandardAction {
    return new StandardAction(
      'duplicate',
      'copy',
      'i18n.common.actions.duplicate',
      'i18n.common.actions.duplicate',
    );
  }

  public static getLoadingCsvAction(): StandardAction {
    return new StandardAction(
      'loading-csv',
      'spinner fa-spin',
      '',
      'i18n.common.generating-csv',
    );
  }
}
